import React, { useCallback } from 'react';
import { AnalyticsListener } from '@atlaskit/analytics-next';
import { ANALYTICS_BRIDGE_CHANNEL } from '@atlassian/analytics-bridge';
export const AnalyticsProvider = ({
  children,
  channel
}) => {
  const sendEvent = useCallback(event => {
    var _event$clone;
    // For backwards compatibility with analytics listeners in the product
    // which attempt to determine the actionSubject and attributes
    // from the context.
    const {
      actionSubject,
      attributes
    } = event.payload;
    const context = {};
    if (actionSubject) {
      context.component = actionSubject;
      context.componentName = actionSubject;
    }
    if (attributes) {
      context.attributes = attributes;
    }
    event.context.push(context);
    (_event$clone = event.clone()) === null || _event$clone === void 0 ? void 0 : _event$clone.fire(channel);
  }, [channel]);
  return /*#__PURE__*/React.createElement(AnalyticsListener, {
    channel: ANALYTICS_BRIDGE_CHANNEL,
    onEvent: sendEvent
  }, children);
};